import React, { Component } from 'react';
import * as messages from '../../messages';
import Card from '@material-ui/core/Card';
import classes from './../../index.css';
import CardHeader from '@material-ui/core/CardHeader';
import PersonIcon from "@material-ui/icons/PersonOutlined";


class Application extends Component {
    render() {
        return <Card>
            <CardHeader title={messages.NS_STUDENT_PANEL} className={classes.Head} />
            <p style={{textAlign: 'center', color: '#252e4a'}}><PersonIcon fontSize="large" style={{ fontSize: '70px', marginTop: '35px' }} /></p>
            <p style={{padding: '10px', textAlign: 'justify'}}>{messages.NS_STUDENT_PANEL_DESCRIPTION}</p>
        </Card>
    }
}

export default Application;

